import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/InternDashboard.css';

const InternDashboard = () => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAssignments = async () => {
      const internEmail = localStorage.getItem('internEmail');
      if (!internEmail) {
        navigate('/'); // redirect if not logged in
        return;
      }

      try {
        const BASE_URL = window.location.origin.includes('localhost')
          ? 'http://localhost:5000'
          : 'https://cveysolutions.in';

        const response = await axios.get(`${BASE_URL}/api/intern/status/${internEmail}`);
        if (response.status === 200 && response.data) {
          const assignmentArray = Object.keys(response.data).map((key, index) => ({
            id: index + 1,
            name: `Assignment ${index + 1}`,
            status: response.data[key] || 'Pending',
          }));
          setAssignments(assignmentArray);
        } else {
          console.error('Error: unexpected response', response);
        }
      } catch (err) {
        console.error('Error fetching assignments:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAssignments();
  }, [navigate]);

  const allCompleted = assignments.length > 0 && assignments.every(a => a.status === 'Completed');

  const handleLogout = () => {
    localStorage.removeItem('internEmail');
    navigate('/');
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <h2>Loading your dashboard...</h2>
      </div>
    );
  }

  return (
    <div className="intern-dashboard-container">
      <button className="logout-btn" onClick={handleLogout}>Logout</button>

      <div className="dashboard-card">
        <h1 className="title">Welcome, Intern! 👋</h1>
        <p className="subtitle">Track your assignments and progress here.</p>

        <div className="assignments-list">
          {assignments.map((assignment, index) => (
            <div key={assignment.id} className={`assignment-item ${index % 2 === 0 ? 'alt-bg-1' : 'alt-bg-2'}`}>
              <span className="assignment-name">{assignment.name}</span>
              <button className={`status-button ${assignment.status.toLowerCase()}`}>
                {assignment.status}
              </button>
            </div>
          ))}
        </div>

        <button
          className={`generate-certificate-btn ${allCompleted ? 'enabled' : 'disabled'}`}
          disabled={!allCompleted}
        >
          Generate Certificate
        </button>
      </div>
    </div>
  );
};

export default InternDashboard;
